import { useState } from "react";
import { X } from "lucide-react";
import { theme } from "../../../utils/theme";

const PrintServicesCard = ({
    form,
    setForm,
    isEditing,
    onEdit,
    onCancel,
    onSave,
    type = "printShop", // printShop | supplier | specialist
}) => {
    const t = theme[type];

    const [newService, setNewService] = useState("");

    const services = form.selectedSupplies || [];
    const customServices = form.customSupplies || [];

    // REMOVE SERVICE
    const removeService = (item) => {
        setForm((prev) => ({
            ...prev,
            selectedSupplies: prev.selectedSupplies.filter((i) => i !== item),
        }));
    };

    // REMOVE CUSTOM
    const removeCustom = (item) => {
        setForm((prev) => ({
            ...prev,
            customSupplies: (prev.customSupplies || []).filter((i) => i !== item),
        }));
    };

    // ADD CUSTOM
    const addService = () => {
        if (!newService.trim()) return;

        setForm((prev) => ({
            ...prev,
            customSupplies: [...(prev.customSupplies || []), newService.trim()],
        }));

        setNewService("");
    };

    return (
        <div className="bg-white rounded-[16px] border border-[#e4e5e7] overflow-hidden">

            {/* HEADER */}
            <div className="px-[20px] py-[14px] border-b border-[#f0f1f3]">
                <div className="flex items-center justify-between">
                    <p className="font-semibold text-[15px] text-[#212326]">
                        Print Services
                    </p>

                    {!isEditing ? (
                        <button
                            onClick={onEdit}
                            className="px-[14px] py-[7px] rounded-[10px] font-semibold text-[13px] text-white"
                            style={{ backgroundColor: t.primary }}
                        >
                            Edit
                        </button>
                    ) : (
                        <div className="flex items-center gap-[8px]">
                            <button
                                onClick={onCancel}
                                className="px-[14px] py-[7px] rounded-[10px] font-semibold text-[13px]"
                                style={{
                                    backgroundColor: t.accentBg,
                                    color: t.primary,
                                }}
                            >
                                Cancel
                            </button>

                            <button
                                onClick={onSave}
                                className="px-[14px] py-[7px] rounded-[10px] font-semibold text-[13px] text-white"
                                style={{ backgroundColor: t.primary }}
                            >
                                Save
                            </button>
                        </div>
                    )}
                </div>
            </div>

            {/* VIEW MODE */}
            {!isEditing && (
                <div className="p-[20px] flex flex-wrap gap-[8px]">
                    {services.map((item) => (
                        <span
                            key={item}
                            className="pl-[12px] pr-[6px] py-[6px] rounded-[10px] font-semibold text-[13px] flex items-center gap-[6px]"
                            style={{
                                backgroundColor: t.accentBg,
                                color: t.primary,
                            }}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                class="lucide lucide-printer w-[12px] h-[12px]">
                                <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path>
                                <path d="M6 9V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6"></path>
                                <rect x="6" y="14" width="12" height="8" rx="1"></rect>
                            </svg>
                            {item}
                        </span>
                    ))}

                    {customServices.map((item) => (
                        <span
                            key={item}
                            className="pl-[12px] pr-[6px] py-[6px] rounded-[10px] font-semibold text-[13px] flex items-center gap-[6px]"
                            style={{
                                backgroundColor: t.accentBg,
                                color: t.primary,
                            }}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                class="lucide lucide-printer w-[12px] h-[12px]">
                                <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path>
                                <path d="M6 9V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6"></path>
                                <rect x="6" y="14" width="12" height="8" rx="1"></rect>
                            </svg>
                            {item}
                        </span>
                    ))}
                </div>
            )}

            {/* EDIT MODE */}
            {isEditing && (
                <div className="p-[20px]">

                    {/* TAGS */}
                    <div className="flex flex-wrap gap-[8px] mb-[12px]">
                        {services.map((item) => (
                            <span
                                key={item}
                                className="pl-[12px] pr-[6px] py-[6px] rounded-[10px] font-medium text-[13px] flex items-center gap-[6px]"
                                style={{
                                    backgroundColor: t.accentBg,
                                    color: t.primary,
                                }}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                    class="lucide lucide-printer w-[12px] h-[12px]">
                                    <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path>
                                    <path d="M6 9V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6"></path>
                                    <rect x="6" y="14" width="12" height="8" rx="1"></rect>
                                </svg>
                                {item}
                                <button
                                    onClick={() => removeService(item)}
                                    className="w-[18px] h-[18px] rounded-full flex items-center justify-center"
                                    style={{ backgroundColor: "rgba(0,0,0,0.05)" }}
                                >
                                    <X className="w-[10px] h-[10px]" />
                                </button>
                            </span>
                        ))}

                        {customServices.map((item) => (
                            <span
                                key={item}
                                className="pl-[12px] pr-[6px] py-[6px] rounded-[10px] font-medium text-[13px] flex items-center gap-[6px]"
                                style={{
                                    backgroundColor: t.accentBg,
                                    color: t.primary,
                                }}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                    class="lucide lucide-printer w-[12px] h-[12px]">
                                    <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path>
                                    <path d="M6 9V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6"></path>
                                    <rect x="6" y="14" width="12" height="8" rx="1"></rect>
                                </svg>
                                {item}
                                <button
                                    onClick={() => removeCustom(item)}
                                    className="w-[18px] h-[18px] rounded-full flex items-center justify-center"
                                    style={{ backgroundColor: "rgba(0,0,0,0.05)" }}
                                >
                                    <X className="w-[10px] h-[10px]" />
                                </button>
                            </span>
                        ))}
                    </div>

                    {/* ADD INPUT */}
                    <div className="flex gap-[8px]">
                        <input
                            value={newService}
                            onChange={(e) => setNewService(e.target.value)}
                            placeholder="Add a print service…"
                            className={`flex-1 h-[40px] rounded-[10px] border border-[#e4e5e7] focus:border-[${t.primary}] px-[14px] font-medium text-[13px] text-[#212326] placeholder:text-[#9298a0] focus:outline-none`}
                        />

                        <button
                            onClick={addService}
                            className="px-[14px] h-[40px] rounded-[10px] text-white font-semibold text-[13px]"
                            style={{ backgroundColor: t.primary }}
                        >
                            Add
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default PrintServicesCard;